export default "__VITE_ASSET__B5QRNaj6__"